
<p-toast position="top-right" key="msj"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" key="kc" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
  rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar" [rejectVisible]="false">
</p-confirmDialog>
<div class="container-fluid" style="border-color: blue; border: 5px ; width: 100%;">
  <div class="row">
    <div class="col-md-12">
      <div class="card card-shadow sinborde">
        <div class="row d-flex justify-content-end">
          <div class="card-header sinborde" style="background: none; ">
            <div class="cardicono rounded">
              <i class="pi pi-compass mt-3" style="font-size: 2rem; color: #fff;"></i>
            </div>
            <header style="left: 11%; top: 5%;">
              <div style="display:inline">Modulo para Consulta de Kilometraje</div>
              <div *ngIf="dia.length > 0" style="color:#834aed;display:inline;" class="ml-3"> - {{dia |
                date: 'dd/MM/yyyy'}} </div>
            </header>
            <div>
              <form [formGroup]="consMantenimientoForm">
                <div class="row align-items-center justify-content-center mt-4">

                  <!-- Icono + Texto Ciudad -->
                  <div class="col-md-2 d-flex align-items-center">
                    <i class="pi pi-shop me-2" style="font-size: 2rem; color: #3B82F6;"></i>
                    <span class="d-none d-md-inline"><b>Ciudad</b></span>
                  </div>

                  <!-- Dropdown de Ciudad -->
                  <div class="col-md-4">
                    <p-dropdown [options]="lstCiudades" autoWidth="false" [style]="{'width':'100%'}"
                      placeholder="Seleccione Ciudad*" formControlName="id_ciudad_hm" optionLabel="nombre"
                      [showClear]="true" optionValue="id">
                    </p-dropdown>
                  </div>

                  <!-- Botón Filtrar -->
                  <div class="col-md-2 mt-2 mt-md-0">
                    <button [disabled]="loadingManetnimiento" type="button" class="custom-out" style="width: 100%;"
                      (click)="getMantenimiento()"><i class="pi pi-filter"></i>
                      <b>&nbsp;Filtrar</b>
                    </button>
                  </div>

                  <!-- Botón Exportar -->
                  <div class="col-md-2 mt-2 mt-md-0">
                    <button [disabled]="loadingManetnimiento_reporte" type="button" class="custom-exc"
                      style="width: 100%;" (click)="exportarExcelMantenimiento()"><i class="pi pi-file-excel"></i>
                      <b>&nbsp;Exportar</b>
                    </button>
                  </div>

                </div>
              </form>
            </div>
            <!--<div class="row d-flex justify-content-end">
              <div class="col-md-12">
                <div class="form-group row mt-5">
                  <div class="col-md-10">
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-4">
                            <form [formGroup]="consMantenimientoForm">
                                <div class="col-md-10 mt-1">
                                    <div class="d-flex align-items-between">
                                        <i class="pi pi-shop color-icon" style="font-size: 2rem; color: #3B82F6;"></i>
                                        <span class="d-none d-xl-inline mr-4"><b>Ciudad</b></span>
                                        <p-dropdown 
                                            [options]="lstCiudades" 
                                            autoWidth="false" 
                                            [style]="{'width':'100%'}"
                                            placeholder="Seleccione Ciudad*" 
                                            formControlName="id_ciudad_hm" 
                                            optionLabel="nombre"
                                            [showClear]="true" 
                                            optionValue="id">
                                        </p-dropdown>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-md-2 ml-3 mt-1">
                            <button [disabled]="loadingManetnimiento" type="button" class="custom-out" style="width: 100%;"
                                (click)="getMantenimiento()"><i class="pi pi-filter"></i>
                                <b>&nbsp;Filtrar</b>
                                </button>
                            </div>
                        <div class="col-md-2 ml-3 mt-1">
                            <button [disabled]="loadingManetnimiento_reporte" type="button" class="custom-exc" style="width: 100%;"
                            (click)="exportarExcelMantenimiento()"><i class="pi pi-file-excel"></i>
                            <b>&nbsp;Exportar</b>
                            </button>
                        </div>  
                        </div>
                    </div>
                  </div>
                </div>
              </div>-->
          </div>
        </div>
      </div>


      <div class="tabla-responsiva-wrapper">
        <p-table #dt1 [value]="lstManteniento" [scrollable]="true" scrollHeight="flex" scrollDirection="both"
          [paginator]="true" [rows]="50" [rowsPerPageOptions]="[100,150,200,300,500]" [showCurrentPageReport]="true"
          currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
          [globalFilterFields]="['num_economico','desc_estatus','ciudad']" [loading]="loading">
          <ng-template pTemplate="caption">

            <div class="row d-flex justify-content-end ">
              <div class="col-12 sm:col-6 xl:col-3">
                <span class="p-input-icon-left">
                  <i class="pi pi-search" style="margin-right: 5px;"></i>
                  <input pInputText pTooltip="Buscar placa, numero economico o VIN" type="text"
                    (input)="applyFilterGlobal($event, 'contains')" placeholder="Buscar #Eco, Estatus"
                    style=" min-width: 100%;" />
                </span>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-left" style="width: 100; min-width: 100px;">Número Económico</th>
              <th class="text-left" style="width: 50; min-width: 50;">Ciudad</th>
              <th class="text-left" pSortableColumn="desc_estatus">Estatus<p-sortIcon field="desc_estatus"></p-sortIcon>
              </th>
              <th class="text-center" pSortableColumn="kim_final_carga">Kilometraje Actual<p-sortIcon
                  field="kim_final_carga"></p-sortIcon></th>
              <th Total class="text-center" pSortableColumn="kim_ultimo_mantenimiento">Kilometraje Último
                Mantenimiento<p-sortIcon field="kim_ultimo_mantenimiento"></p-sortIcon></th>
              <th class="text-center" pSortableColumn="kim_mantenimiento">Kilómetros para Mantenimiento<p-sortIcon
                  field="kim_mantenimiento"></p-sortIcon></th>
              <th class="text-center" pSortableColumn="proximo_mantenimiento">Próximo Mantenimiento<p-sortIcon
                  field="proximo_mantenimiento"></p-sortIcon></th>
              <th class="text-center" pSortableColumn="kim_restantes">Kilometros Restantes<p-sortIcon
                  field="kim_restantes"></p-sortIcon></th>

            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-fol>
            <tr>
              <td class="text-left" style="color: #1e5a9c;">
                <b>{{fol.num_economico}}</b>
              </td>
              <td class="text-left" style="width: 50; min-width: 50;"><b>{{fol.ciudad}}</b></td>
              <td class="text-left" style="width: 50; min-width: 50;"><b>{{fol.desc_estatus}}</b></td>
              <td class="text-center" style="color: #4CAF50FF;"><b>{{fol.kim_final_carga}}</b></td>
              <td class="text-center"><b>{{fol.kim_ultimo_mantenimiento}}</b></td>
              <td class="text-center"><b>{{fol.kim_mantenimiento}}</b></td>
              <td class="text-center"><b>{{fol.proximo_mantenimiento}}</b></td>
              <td class="text-center"><b>{{fol.kim_restantes}}</b></td>

            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
